import { ConnectingModal } from "../../components/ConnectingModal";
import { forwardRef, useEffect, useState } from "react";
import { MedplumLink, useMedplum } from "@medplum/react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../api";
import {
  addAccessTokensToLoginedUser,
  athenaHandler,
  athenaOneHandler,
  cernerHandler,
  checkUrl,
  ecwHandler,
  epicHandler,
  getAccessToken,
  getAndUploadDexcomData,
  getAndUploadFitBitData,
  getAndUploadGarminData,
  getAndUploadGoogleFitData,
  getAndUploadIHealthData,
  getAndUploadOuraData,
  getAndUploadPolarData,
  getAndUploadStravaData,
  getAndUploadWithingsData,
  platformLogo,
  storePatientDataUsingBot,
} from "../../utils";
import {
  Paper,
  Title,
  Flex,
  Button,
  Box,
  Modal,
  MultiSelect,
  UnstyledButton,
  Center,
  Loader,
  Pagination,
  createStyles,
  Select,
  Group,
  Text,
} from "@mantine/core";
import circularVeradigmLogo from "../../assets/img/circularVeradigm.jpeg"
import { MemberTable } from "../MembersTable";
import { getExtensionValues } from "../HomePage.utils";
import { useDispatch } from "react-redux";
import SearchPatientComponent from "../../components/SearchPatient";
import PatientInfoModal, {
  PatientResource,
} from "../../components/PatientInfoModal";
import { CustomTable } from "../../components/Table";
import EEpic from "../../assets/img/EpicPatint.svg";
import cerner from "../../assets/img/CernerPatient.svg";
import aaathena from "../../assets/img/AthenaPatient.svg";
import ecwico from "../../assets/img/ecwpatient.svg";
import nextgenico from "../../assets/img/nextgenico.svg";
import others from "../../assets/img/others.svg";
import { showNotification } from "@mantine/notifications";
import filtersvg from "../../assets/img/Icon Button.svg";
import { formatDate, formatDateTime } from "@medplum/core";
import searchIcon from "../../assets/img/searchIcon.svg";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  Box1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  searchbarBox: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "16px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  selectBox: {
    width: "100%",
    maxWidth: "438px",
    display: "flex",
    flexDirection: "row",
  },
  createVideoAppointment: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  loader: { width: "100%", height: "200px" },
  paginationBox: { display: "flex", justifyContent: "flex-end" },
}));
export interface ExtensionData {
  environment: string;
  integrationType: string;
  launchType: string;
  scope: string;
}

export function PatientList(): JSX.Element {
  const { classes } = useStyles();

  const location = useLocation();
  const medplum = useMedplum();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = new URLSearchParams(location.search);
  const code = query.get("code") as string;
  const state = query.get("state") as string;
  const garminverifier = query.get("oauth_verifier") as string;
  const thirdPartyVendor = query.get("vendor") as string;
  const [isPatientFetched, setIsPatientFetched] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isConnecting, setIsConnecting] = useState<boolean>(true);
  const [vendor, setVendor] = useState("");
  const [patientToShow, setPatientToShow] = useState<PatientResource>();
  const [isPatientModalOpen, setIsPatientModalOpen] = useState<boolean>(false);
  const [selectedEHR, setSelectedEHR] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [patient, setPatient] = useState<any>([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filter, setFilter] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setStatus] = useState<string[]>([]);
  const [total, setTotal] = useState<any>("");
  const [clicked, setClicked] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [patientlist, setPatientlist] = useState<any>([]);

  async function generateTokenAndGetResource(code: string) {
    setIsModalOpen(true);
    try {
      const activeLogin = getAccessToken();
      const activeClient = JSON.parse(
        localStorage.getItem("activeClient") || "{}"
      );

      if (
        !activeClient ||
        !activeClient.entry ||
        !activeClient.entry[0] ||
        !activeClient.entry[0].resource
      ) {
        console.error("Invalid or missing active client information.");
        return;
      }
      const { clientId, tokenUrl, userInfoUrl } =
        activeClient.entry[0].resource.identityProvider;
      const { redirectUri, id, meta, name } = activeClient.entry[0].resource;

      if (!clientId || !tokenUrl || !userInfoUrl || !redirectUri) {
        console.error("Missing required information for token generation.");
        return;
      }
      const additionalFields = getExtensionValues(meta, "additionalFields");

      let tokenData;
      setVendor(additionalFields?.integrationType as string);
      if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "cerner"
      ) {
        const tokenPayload = {
          eventType: "token",
          code,
          clientId: id,
        };
        const res = await cernerHandler(medplum, tokenPayload);
        tokenData = res.body;
      } else if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "athenahealth"
      ) {
        const tokenPayload = {
          eventType: "token",
          code,
          clientId: id,
        };
        const res = await athenaHandler(medplum, tokenPayload);
        tokenData = res.body;
      }
      // else if (
      //   (additionalFields?.integrationType as string)?.toLowerCase() ===
      //   "athenaone"
      // ) {
      //   const tokenPayload = {
      //     eventType: "token",
      //     code,
      //     clientId: id,
      //   };
      //   const res = await athenaOneHandler(medplum, tokenPayload);
      //   tokenData = res.body;
      // }
      else if (
        ["ecw", "eclinicalworks", "nextgen", "athenaone",'veradigm'].includes(
          (additionalFields?.integrationType as string)?.toLowerCase()
        )
      ) {
        const tokenPayload = {
          eventType: "token",
          code,
          clientId: id,
        };
        const res = await ecwHandler(medplum, tokenPayload);
        tokenData = res.body;
     

      } else {
        const tokenPayload = {
          eventType: "token",
          code,
          clientId: id,
        };
        
        const res = await epicHandler(medplum, tokenPayload);
        tokenData = res.body;
      }
      const accessToken = tokenData?.access_token;
      let patientId = tokenData?.patient;
      await addAccessTokensToLoginedUser(
        medplum,
        dispatch,
        tokenData,
        activeLogin,
        id,
        additionalFields.integrationType as string,
        name
      );

      if (!accessToken) {
        console.error(
          "Invalid response format for access token or patient ID."
        );
        setIsConnecting(false);
        setIsPatientFetched(true);
        setIsModalOpen(false);
        return;
      }

      let patientRes;
      let storedPatientId = "";

      if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "cerner"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId,
          clientId: id,
        };
        const res = await cernerHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        const newIdentifier = [
          {
            system: "cerner_patient_id",
            value: res?.body?.entry[0]?.resource?.id,
          },
        ];
        patientRes = { ...res?.body?.entry[0]?.resource };
        patientRes.identifier = [...patientRes?.identifier, ...newIdentifier];
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.entry[0]?.resource?.id;
      } else if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "athenahealth"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId,
          clientId: id,
        };
        const res = await athenaHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        const newIdentifier = [
          {
            system: "athena_patient_id",
            value: res?.body?.id,
          },
          {
            system: "athena_practitioner_id",
            value: tokenData?.uuid,
          },
        ];
        res.body.identifier = [...res?.body?.identifier, ...newIdentifier];
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
        delete patientRes?.storedId;
      } else if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "athenaone"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId,
          clientId: id,
        };
        const res = await ecwHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        const newIdentifier = [
          {
            system: "athenaone_patient_id",
            value: res?.body?.id,
          },
          {
            system: "athenaone_practitioner_id",
            value: tokenData?.uuid,
          },
        ];
        res.body.identifier = [...res?.body?.identifier, ...newIdentifier];
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
        delete patientRes?.storedId;
      } else if (
        (additionalFields?.integrationType as string)?.toLowerCase() === "ecw"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId,
          clientId: id,
        };
        const res = await ecwHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        const newIdentifier = [
          {
            system: "ecw_patient_id",
            value: res?.body?.id,
          },
          {
            system: "ecw_practitioner_id",
            value: tokenData?.uuid,
          },
        ];
        res.body.identifier = [...res?.body?.identifier, ...newIdentifier];
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
        delete patientRes?.storedId;
      }
      else if (
        (additionalFields?.integrationType as string)?.toLowerCase() === "veradigm"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId:69589,
          clientId: id,
        };
        const res = await ecwHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        const newIdentifier = [
          {
            system: "veradigm_patient_id",
            value: res?.body?.id,
          },
          {
            system: "veradigm_practitioner_id",
            value: tokenData?.uuid,
          },
        ];
        res.body.identifier = [...res?.body?.identifier, ...newIdentifier];
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
        delete patientRes?.storedId;
      }  else if (
        (additionalFields?.integrationType as string)?.toLowerCase() ===
        "nextgen"
      ) {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          clientId: id,
        };
        const res = await ecwHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        res.body = res?.body?.entry[0].resource;
        const newIdentifier = [
          {
            system: "nextgen_patient_id",
            value: res?.body?.id,
          },
        ];
        res.body.identifier = [
          ...(res?.body?.identifier ?? null),
          ...newIdentifier,
        ];
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
      } else {
        const patientPayload = {
          eventType: "patient",
          accessToken,
          patientId,
          clientId: id,
        };
        const res = await epicHandler(medplum, patientPayload);
        storedPatientId = res.body.storedId ?? "";
        patientRes = { ...res?.body };
        if (storedPatientId) patientRes.id = storedPatientId;
        patientId = res?.body?.id;
        delete patientRes?.storedId;
      }

      setIsConnecting(false);
      const createdPatient = storedPatientId
        ? await axios.put(
            API_ENDPOINTS.UPDATE_RESOURCE + "/" + storedPatientId,
            patientRes,
            {
              headers: {
                Authorization: `Bearer ${activeLogin.accessToken}`,
              },
            }
          )
        : await axios.post(API_ENDPOINTS.UPLOAD_PATIENT, patientRes, {
            headers: {
              Authorization: `Bearer ${activeLogin.accessToken}`,
            },
          });

      const createdPatientId =
        createdPatient?.data?.patientResource?.id ??
        createdPatient?.data?.updatedResource?.id;

      const data = {
        epicClientId: clientId,
        epicAccessToken: accessToken,
        storedPatientId: createdPatientId,
        epicPatientId: patientId,
        accessToken: activeLogin.accessToken,
      };

      if (
        (additionalFields?.integrationType as string)?.toLowerCase() == "cerner"
      ) {
        const patientPayload = {
          eventType: "patientResources",
          cernerPatientId: patientId,
          storedPatientId: createdPatientId,
          clientId: id,
          accessToken: accessToken,
        };
        cernerHandler(medplum, patientPayload);
      } else if (
        (additionalFields?.integrationType as string)?.toLowerCase() ==
        "athenahealth"
      ) {
        const patientPayload = {
          eventType: "patientResources",
          athenaPatientId: patientId,
          storedPatientId: createdPatientId,
          clientId: id,
          accessToken: accessToken,
        };

        athenaHandler(medplum, patientPayload);
      }
      // else if (
      //   (additionalFields?.integrationType as string)?.toLowerCase() ==
      //   "athenaone"
      // ) {
      //   const patientPayload = {
      //     eventType: "patientResources",
      //     patientId: patientId,
      //     storedPatientId: createdPatientId,
      //     clientId: id,
      //     accessToken: accessToken,
      //   };

      //   athenaOneHandler(medplum, patientPayload);
      // }
      else if (
        ["ecw", "nextgen", "athenaone",'veradigm'].includes(
          (additionalFields?.integrationType as string)?.toLowerCase()
        )
      ) {
        const patientPayload = {
          eventType: "patientResources",
          patientId: patientId,
          storedPatientId: createdPatientId,
          clientId: id,
          accessToken: accessToken,
        };

        ecwHandler(medplum, patientPayload);
      } else {
        storePatientDataUsingBot(medplum, data);
      }

      navigate(`/patient/details/${createdPatientId}`);
      setIsPatientFetched(true);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Unexpected error:", error);
      setIsPatientFetched(true);
      setIsModalOpen(false);
      setIsConnecting(false);
    }
  }
  const getStatusQueryString = () => {
    if (status.length === 0) {
      return "";
    }

    return "&status=" + status.join(",");
  };

  const getPatientList = async (selectedPatientId?: any) => {
    try {
      if (clicked === true) {
        setIsPatientFetched(true);

        setIsFetching(false);
      } else {
        setIsFetching(true);
      }
      const count = 20;

      let queryString = `_count=${count}&_offset=${
        (currentPage - 1) * count
      }&_sort=-_lastUpdated&_total=accurate`;
      if (selectedPatientId) {
        queryString = `_count=${count}&_offset=${
          (currentPage - 1) * count
        }&_sort=-_lastUpdated&_total=accurate&_id=${selectedPatientId}`;
      } else if (clicked) {
        queryString = `_count=500&_offset=${
          (currentPage - 1) * count
        }&_sort=-_lastUpdated&_total=accurate`;
      } else {
        queryString = `_count=${count}&_offset=${
          (currentPage - 1) * count
        }&_sort=-_lastUpdated&_total=accurate`;
      }
      const res = await medplum.searchResources("Patient", queryString);

      const tt = Math.ceil((res.bundle.total as any) / 20);
      setTotal(tt);

      if (!res || !Array.isArray(res)) {
        console.error("Invalid response format for patient data.");
        return;
      }

      const patientData = res.map((patient) => {
        const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
          (coding) => coding?.system?.includes("cerner")
        );
        const containsAthena = patient?.identifier?.some(
          (item) => item?.system && item?.system.includes("athena")
        );
        const containsEcw = patient?.identifier?.some(
          (item) => item.system && item.system.includes("ecw")
        );
        const containsNextgen = patient?.identifier?.some(
          (item) => item.system && item.system.includes("nextgen")
        );
        const containsAthenaOne = patient?.identifier?.some(
          (item) => item.system && item.system.includes("athenaone")
        );
        const containsVeradigm = patient?.identifier?.some(
          (item) => item.system && item.system.includes("veradigm")
        );
        let ehrtype = "";

        if (
        patient?.identifier?.find(
  (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
)
        ) {
          ehrtype = "EPIC";
        } else if (containsCerner) {
          ehrtype = "Cerner";
        } else if (containsAthenaOne) {
          ehrtype = "Athena One";
        } else if (containsAthena) {
          ehrtype = "Athena Health";
        } else if (containsEcw) {
          ehrtype = "ECW";
        } else if (containsNextgen) {
          ehrtype = "NextGen";
        } else if (containsVeradigm) {
          ehrtype = "Veradigm";
        } 
        else {
          ehrtype = "Others";
        }
        let EHRIcon;

        switch (ehrtype) {
          case "EPIC":
            EHRIcon = (
              <img src={EEpic} style={{ marginRight: "10px" }} alt="EPIC" />
            );
            break;
          case "Cerner":
            EHRIcon = (
              <img src={cerner} style={{ marginRight: "10px" }} alt="Cerner" />
            );
            break;
          case "Athena Health":
            EHRIcon = (
              <img
                src={aaathena}
                style={{ marginRight: "10px" }}
                alt="Athena"
              />
            );
            break;
          case "ECW":
            EHRIcon = (
              <img src={ecwico} style={{ marginRight: "10px" }} alt="ECW" />
            );
            break;
          case "NextGen":
            EHRIcon = (
              <img
                src={nextgenico}
                style={{ marginRight: "10px" }}
                alt="NextGen"
              />
            );
            break;
            case "Veradigm":
              EHRIcon = (
                <img
                  src={circularVeradigmLogo}
                  style={{ marginRight: "8px",height:"23px" }}
                  alt="NextGen"
                />
              );
              break;
          case "Athena One":
            EHRIcon = (
              <img
                src={aaathena}
                style={{ marginRight: "10px" }}
                alt="AthenaOne"
              />
            );
            break;
          default:
            EHRIcon = (
              <img
                src={others}
                style={{ marginRight: "10px", width: "20px", height: "40px" }}
                alt="NA"
              />
            );
        }
        const gender = patient?.gender ?? "";
        const formattedGender =
          gender?.charAt(0)?.toUpperCase() + gender?.slice(1)?.toLowerCase();

        return {
          value: patient?.id,
          label: getPatientName(patient?.name),
          gender: formattedGender,
          dob: formatDate(patient?.birthDate),
          ehrdata: [EHRIcon, ehrtype],

          lastupdated: formatDateTime(patient?.meta?.lastUpdated),
        };
      });

      if (clicked === true) {
        setPatientlist(patientData);
        setClicked(false);
      } else {
        setPatient(patientData);
      }

      setIsFetching(false);
      setIsPatientFetched(false);
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setIsFetching(false);
      showNotification({
        color: "red",
        message: "Something went wrong",
        autoClose: true,
      });
    }
  };

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if (
          (res?.use === "official" || res?.use === "usual") &&
          name === "--"
        ) {
          name = res?.text || res?.given[0];
        }
      });
      if (name === "--")
        name = patientData[0]?.text || patientData[0]?.given || "--";
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  };

  async function generateTokenForGoogleFit() {
    const authURL = window.location.href;
    const activeClient = JSON.parse(
      localStorage.getItem("activeClient") || "{}"
    );
    const patientId = localStorage.getItem("selectedPatient") || "";
    try {
      setIsModalOpen(true);
      const { id, secret, redirectUri } = activeClient;
      let uploadSuccess = null;
      if (state === "Google Fit") {
        uploadSuccess = await getAndUploadGoogleFitData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Dexcom") {
        uploadSuccess = await getAndUploadDexcomData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Fitbit") {
        uploadSuccess = await getAndUploadFitBitData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Oura") {
        uploadSuccess = await getAndUploadOuraData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Polar") {
        uploadSuccess = await getAndUploadPolarData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Withings") {
        uploadSuccess = await getAndUploadWithingsData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (state === "Strava") {
        uploadSuccess = await getAndUploadStravaData(
          authURL,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (
        checkUrl(activeClient?.identityProvider?.authorizeUrl, "ihealthlabs")
      ) {
        uploadSuccess = await getAndUploadIHealthData(
          code,
          id,
          redirectUri,
          patientId,
          secret,
          medplum
        );
      } else if (checkUrl(window.location.href, "oauth_verifier")) {
        const oauthData = JSON.parse(
          localStorage.getItem("GARMIN_AUTH") as string
        );
        uploadSuccess = await getAndUploadGarminData(
          oauthData,
          id,
          garminverifier,
          patientId,
          secret,
          medplum
        );
      }
      if (uploadSuccess) {
        navigate(`/patient/details/${patientId}?clientId=${id}`);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setIsModalOpen(false);
      setIsConnecting(false);
      localStorage.removeItem("activeClient");
    }
  }
  useEffect(() => {
    getPatientList();
  }, [currentPage]);
  useEffect(() => {
    if (clicked === true) {
      getPatientList();
    }
  }, [clicked]);

  useEffect(() => {
    const activeClient = JSON.parse(
      localStorage.getItem("activeClient") || "{}"
    );
    setVendor(
      checkUrl(window.location.href, "oauth_verifier")
        ? "garmin"
        : checkUrl(activeClient?.identityProvider?.authorizeUrl, "ihealthlabs")
        ? "ihealth"
        : state
    );
    if (code) {
      setIsPatientFetched(false);
    }
    if (
      [
        "Google Fit",
        "Dexcom",
        "Fitbit",
        "Oura",
        "Polar",
        "Withings",
        "Strava",
      ].includes(state) ||
      checkUrl(window.location.href, "oauth_verifier") ||
      checkUrl(activeClient?.identityProvider?.authorizeUrl, "ihealthlabs")
    ) {
      generateTokenForGoogleFit();
    } else if (code || ["athenaHealth"].includes(state)) {
      generateTokenAndGetResource(code);
    }
  }, []);

  const handlePatientModalClose = (patientId: string) => {
    setIsPatientModalOpen(false);
    navigate(`/patient/details/${patientId}`);
  };
  function handleClick(rowData: any) {
    if (rowData && rowData.value) {
      navigate("/patient/details/" + rowData?.value);
    } else {
      showNotification({
        color: "red",
        message: "Not found",
        autoClose: true,
      });
    }
  }

  const handleChange = (selectedStatus: string[]) => {
    getPatientList();
    const lowercaseStatus = selectedStatus.map((status) =>
      status.toLowerCase()
    );
    setFilter(lowercaseStatus);
  };
  const handleApply = () => {
    const filteredData = patient.filter((e: any) => {
      return filter?.includes(e?.ehrdata[1].toLowerCase());
    });

    setPatient(filteredData);
    setIsFilterModalOpen(false);
  };
  const modelOpen = () => {
    // getPatientList();
    setIsFilterModalOpen(true);
  };
  const capitalizedFilter = filter.map((s: string) => {
    const words = s.split(" ");
    const capitalizedWords = words.map((word: string) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return capitalizedWords.join(" ");
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
    gender: any;
    dob: any;
    ehrdata: any;
    lastupdated: any;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    (
      { value, label, gender, dob, ehrdata, lastupdated, ...others }: ItemProps,
      ref
    ) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: "space-between",
            height: "30px",
            width: "100%",
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{ehrdata?.[0]}</div>
        </Group>
      </div>
    )
  );

  return (
    <>
      <Modal
        opened={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        size="md"
        withCloseButton={false}
        closeOnEscape={true}
        closeOnClickOutside={true}
      >
        <Box sx={{ paddingTop: "20px", minHeight: "225px" }}>
          <MultiSelect
            data={[
              "Epic",
              "Cerner",
              "Athena Health",
              "NextGen",
              "ECW",
              "Athena One",
              "Others",
            ]}
            label="Choose EHR type for filter"
            placeholder="Select filter"
            nothingFound="Nothing found"
            maxDropdownHeight={125}
            dropdownPosition="bottom"
            onChange={handleChange}
            defaultValue={[...capitalizedFilter]}
            clearable={true}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleApply}
            disabled={filter.length === 0 ? true : false}
          >
            Apply
          </Button>
        </Box>
      </Modal>
      <ConnectingModal
        isOpen={isModalOpen}
        isConnecting={isConnecting}
        onClose={() => {}}
        vendor={vendor}
      />
      {isPatientModalOpen && patientToShow && (
        <PatientInfoModal
          isOpen={isPatientModalOpen}
          onClose={handlePatientModalClose}
          ehrType={selectedEHR}
          ehrImage={platformLogo[selectedEHR]}
          ehrName={selectedEHR}
          patientDetails={patientToShow}
          medplum={medplum}
          searchTerm={searchTerm}
          setIsPatientModalOpen={setIsPatientModalOpen}
        />
      )}

      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box>
              <Box className={classes.Box1}>
                <Title className={classes.title}>Patients</Title>
                <Box>
                  <MedplumLink to={`/patient/new`}>
                    <Button type="button" onClick={() => {}}>
                      + New Patient
                    </Button>
                  </MedplumLink>
                </Box>
              </Box>

              {/* searchbar */}
              <Box className={classes.searchbarBox}>
                <Box className={classes.selectBox}>
                  <Select
                    icon={<img src={searchIcon} />}
                    placeholder={
                      isPatientFetched
                        ? "Fetching patient list..."
                        : "Search Patients"
                    }
                    required={true}
                    data={patientlist}
                    // disabled={isPatientFetched ? true : false}
                    rightSection={
                      isPatientFetched ? <Loader size={"sm"} /> : ""
                    }
                    size="lg"
                    radius="md"
                    onClick={() => {
                      setClicked(true);
                    }}
                    onChange={(val) => {
                      setSelectedPatient(val);
                      getPatientList(val);
                    }}
                    clearable={true}
                    sx={{
                      ".mantine-Select-itemsWrapper": {
                        paddingRight: "10px",
                      },
                    }}
                    searchable
                    // rightSection={<IconChevronDown size="1rem" />}
                    itemComponent={SelectItem}
                  />
                  <Box pl={"20px"}>
                    <UnstyledButton onClick={modelOpen}>
                      <img src={filtersvg} alt="filter" />
                    </UnstyledButton>
                  </Box>
                </Box>

                <Box>
                  <SearchPatientComponent
                    setPatientToShow={setPatientToShow}
                    setIsPatientModalOpen={setIsPatientModalOpen}
                    setSelectedEHR={setSelectedEHR}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    isPatientModalOpen={isPatientModalOpen}
                  />
                </Box>
              </Box>
            </Box>
            {/* table */}
            <Box>
              <Box sx={{ paddingBottom: "16px" }}>
                {isFetching ? (
                  <Center className={classes.createVideoAppointment}>
                    <Loader />
                  </Center>
                ) : (
                  <Box>
                    <CustomTable
                      showActionColumn={false}
                      head={[
                        "Patient ID",
                        "Name",
                        "Gender",
                        "BirthDate",
                        "EHR Type",
                        "Last Updated",
                      ]}
                      data={patient}
                      handleClick={(e: any) => handleClick(e)}
                    />

                    <Box className={classes.paginationBox}>
                      <Pagination
                        total={total}
                        onChange={handlePageChange}
                        defaultValue={currentPage}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>{" "}
      </Paper>
    </>
  );
}
